"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formFeedbackText = void 0;

var _stylitas = require("@creditas/stylitas");

const feedbackSuccess = ({
  theme
}) => (0, _stylitas.css)`
  color: ${theme.bColorsuccess};
`;

const feedbackError = ({
  theme
}) => (0, _stylitas.css)`
  color: ${theme.bColordanger};
`;

const feedbackWarning = ({
  theme
}) => (0, _stylitas.css)`
  color: ${theme.bColorwarning};
`;

const formFeedbackText = ({
  success,
  error,
  warning,
  ...props
}) => (0, _stylitas.css)`
  ${_stylitas.utilities.typography.support(props.theme)}
  margin-top: 8px;
  margin-bottom: 0;
  ${success && feedbackSuccess(props)};
  ${warning && feedbackWarning(props)};
  ${error && feedbackError(props)};
`;

exports.formFeedbackText = formFeedbackText;